import * as React from "react"
const AnalyticsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="#fff"
      d="M407.906 159.426C399.616 159.426 392.895 166.147 392.895 174.437V443.145H480.722V174.437C480.722 166.147 474.001 159.426 465.711 159.426H407.906Z"
    />
    <path
      fill="#fff"
      d="M286.498 262.66C278.207 262.66 271.486 269.381 271.486 277.671V443.147H359.314V277.671C359.314 269.381 352.593 262.66 344.303 262.66H286.498Z"
    />
    <path
      fill="#fff"
      d="M497.088 472.945H15.0112C6.72101 472.945 0 479.666 0 487.957C0 496.247 6.72101 502.968 15.0112 502.968H497.088C516.827 502.303 517.113 473.729 497.088 472.945Z"
    />
    <path
      fill="#fff"
      d="M116.497 315.699C116.497 307.409 109.776 300.688 101.486 300.688H43.6811C35.3909 300.688 28.6699 307.409 28.6699 315.699V443.145H116.496L116.497 315.699Z"
    />
    <path
      fill="#fff"
      d="M165.09 224.738C156.8 224.738 150.079 231.459 150.079 239.749V443.147H237.906V239.749C237.906 231.459 231.185 224.738 222.894 224.738H165.09Z"
    />
    <path
      fill="#fff"
      d="M73.9248 262.923C106.436 263.421 128.591 227.825 114.369 198.947L168.436 144.88C182.195 153.863 201.532 154.054 215.473 145.357L273.363 175.573C278.325 194.896 295.892 209.219 316.742 209.219C345.823 209.666 368.033 180.358 359.901 152.522L418.415 94.0089C447.392 108.799 483.364 86.5053 482.93 53.8219C482.93 29.1295 462.841 9.04154 438.149 9.04154C406.094 8.49013 383.591 43.7514 397.464 72.5019L342.281 127.684C320.903 112.082 288.624 120.431 277.093 143.655L234.705 121.529C244.828 92.9752 222.681 61.8569 192.331 62.2222C162.197 61.8549 140.054 92.5969 149.802 121.057L93.1401 177.719C76.5117 169.84 55.9984 172.761 42.2602 186.498C14.0691 214.562 34.5965 263.19 73.9248 262.923Z"
    />
  </svg>
)
export default AnalyticsIcon
